import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppServices } from "../../../hook/services";
import AssignUserSimModal from "./components/Modals/AssignUserSim";
import DataTable from "./components/DataTable";
import LoadingScreen from "../../../components/LoadingScreen";

const LocationUsers = () => {
  const { locationId } = useParams();
  const AppService = useAppServices();
  const [users, setUsers] = useState([]);
  const [locationInfo, setLocationInfo] = useState(null);
  const [processing, setProcessing] = useState(true);

  const getData = async () => {
    try {
      const { response } = await AppService.user.get({
        query: `locationId=${locationId}`,
      });
      if (response) {
        setUsers(response.data);
        setProcessing(false);
      } else {
        setProcessing(false);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setProcessing(false);
    }
  };

  const getLocationInfo = async () => {
    // Mock location info based on ID
    const { response } = await AppService.account.GetLocationsById({
      query: `locationId=${locationId}`,
    });
    // console.log("responseresponseresponse", response);
    setLocationInfo(response?.accounts || {});
  };
  let pageLoad = true;
  useEffect(() => {
    if (pageLoad) {
      getData();
      getLocationInfo();
      pageLoad = false;
    }
  }, []);

  const columns = [
    {
      label: "Name",
      key: "name",
      sortable: true,
      renderCell: (user) => (
        <div className="d-flex align-items-center">
          <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
            <i className="bi bi-person text-primary"></i>
          </div>
          <div>
            <span className="mb-0 text-dark">{user.username}</span>
            <small className="text-muted">{user.phone}</small>
          </div>
        </div>
      ),
    },
    {
      label: "Email",
      key: "email",
      sortable: false,
      renderCell: (user) => <span className="text-dark">{user.email}</span>,
    },
    {
      label: "Connected Sim",
      key: "connectedSim",
      sortable: false,
      renderCell: (user) =>
        user.connectedSim?.sim_number || "No Sim Connected Yet",
    },
    {
      label: "WhatsApp",
      key: "whatsapp",
      sortable: false,
      renderCell: () => (
        <button
          className="btn btn-success px-4 py-2 rounded-3 shadow-sm"
          style={{ fontSize: "0.875rem" }}
        >
          <i className="bi bi-whatsapp me-2"></i>
          Connect WhatsApp
        </button>
      ),
    },
    {
      label: "Role",
      key: "ghl_role",
      sortable: false,
      renderCell: (user) => (
        <span className="badge bg-light text-dark border">{user.ghl_role}</span>
      ),
    },
    {
      label: "SIM",
      key: "assignSim",
      sortable: false,
      renderCell: (user) => (
        <AssignUserSimModal user={user} handleRefresh={getData} />
      ),
    },
  ];

  if (processing) {
    return <LoadingScreen loadingText={"Loading users..."} />;
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#F5F6FA" }}>
      <div className="container-fluid p-4">
        {/* Header Card */}
        <div
          className="card border-0 shadow-sm mb-4"
          style={{ backgroundColor: "white" }}
        >
          <div className="card-body py-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-0 fw-bold text-dark">
                  {locationInfo?.name} - Users
                </h4>
                <p className="text-muted mb-0 small">
                  Manage users and their SIM assignments for this location
                </p>
              </div>
              {/* <div className="d-flex gap-2">
                <button className="btn btn-primary px-4 py-2 rounded-3 shadow-sm">
                  <i className="bi bi-sim me-2"></i>
                  Assign Default Sim
                </button>
                <button
                  type="button"
                  className="btn btn-success px-4 py-2 rounded-3 shadow-sm"
                  style={{ fontSize: "0.875rem" }}
                >
                  <i className="bi bi-whatsapp me-2"></i>
                  Default WhatsApp Connection
                </button>
              </div> */}
            </div>
          </div>
        </div>

        <DataTable columns={columns} data={users} entriesPerPage={10} />
      </div>
    </div>
  );
};

export default LocationUsers;
